import React, { useState } from 'react';
import CreateLycee from './CreateLycee';
import CreateClasse from './CreateClasse';
import { ValidationStep } from './ValidationStep';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { FlatIcon } from '../../../atoms/Icons/FlatIcon';
import useStyle from './createLyceeStep.style';
import { classNames } from '../../../../helpers/style/classNames';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/reducers';

const CreateLyceeClasseStep = () => {
  const [step, setStep] = useState<number>(0);
  const { createClasse, createLycee } = useSelector((state: AppState) => state);
  const classes = useStyle();

  return (
    <FeatureContainer>
      <div>
        <div className={classes.stepper}>
          <div className={classes.step}>
            <div className={classes.stepContentContainer}>
              <div className={classes.stepContent}>
                {step >= 1 ? (
                  <FlatIcon icon={'Tick'} color={'white'} />
                ) : (
                  <p>1</p>
                )}
              </div>
              <p>Création du lycée</p>
            </div>
            <span
              className={classNames([classes.stepIndicator], {
                condition: step >= 1,
                classe: classes.stepIndicatorOn
              })}
            />
          </div>
          <div className={classes.step}>
            <div className={classes.stepContentContainer}>
              <div className={classes.stepContent}>
                {step >= 2 ? (
                  <FlatIcon icon={'Tick'} color={'white'} />
                ) : (
                  <p>2</p>
                )}
              </div>
              <p>Création de la classe</p>
            </div>
            <span
              className={classNames([classes.stepIndicator], {
                condition: step >= 2,
                classe: classes.stepIndicatorOn
              })}
            />
          </div>
          <div className={classes.step}>
            <div className={classes.stepContentContainer}>
              <div className={classes.stepContent}>
                {step >= 3 ? (
                  <FlatIcon icon={'Tick'} color={'white'} />
                ) : (
                  <p>3</p>
                )}
              </div>
              <p>Validation</p>
            </div>
            <span
              className={classNames([classes.stepIndicator], {
                condition: step >= 3,
                classe: classes.stepIndicatorOn
              })}
            />
          </div>
        </div>
      </div>
      {step === 0 && <CreateLycee step={step} setStep={setStep} />}
      {step === 1 && <CreateClasse step={step} setStep={setStep} />}
      {step === 2 && (
        <ValidationStep
          classe={createClasse.values}
          lycee={createLycee.values}
          setStep={setStep}
          step={step}
        />
      )}
    </FeatureContainer>
  );
};

export default CreateLyceeClasseStep;
